import { options, vTooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'

export function useTooltip (themeName) {
    const canHover = window.matchMedia( "(hover: hover)" ).matches

    options.themes[themeName] = {
        $extend: 'tooltip',
        $resetCss: true
    }
    if (!canHover) {
        options.themes[themeName].triggers = ['click']
        options.themes[themeName].autoHide = true
    }

    const createTooltip = (content) => ({
        content,
        theme: themeName
    })

    return {
        vTooltip,
        createTooltip
    }
}
